export default __webpack_public_path__ + "assets/images/dd5043df15510003a7b5781094c0fe35.svg";